import { IMessages, IModals, IPageAwareState, IPanels, IViewOptions } from "../Contracts";
import { Themes } from "../../../../common/Constants";

export function getPanels(state: IPageAwareState): IPanels | undefined {
    if(!state || !state.pageViewState) {
        return undefined;
    }

    return state.pageViewState.panels;
}

export function getModals(state: IPageAwareState): IModals | undefined {
    if(!state || !state.pageViewState) {
        return undefined;
    }


    return state.pageViewState.modals;
}

export function getTheme(state: IPageAwareState): Themes {
    if (!state || !state.pageViewState || !state.pageViewState.theme) {
        return Themes.Default;
    }
    return state.pageViewState.theme;
}

export function getMessages(state: IPageAwareState) : IMessages | undefined {
    if(!state || !state.pageViewState) {
        return undefined;
    }

    return state.pageViewState.messages;
}

export function getViewOptions(state: IPageAwareState) : IViewOptions | undefined {
    if(!state || !state.pageViewState || !state.pageViewState.viewOptions) {
        return undefined;
    }

    return state.pageViewState.viewOptions;
}
